import { requireComponent } from '@/utils'
import Layout from '@/layout/index.vue'

const dir = process.env.NODE_ENV === 'development' ? '/UGC' : ''
const UGCRouter = [
  {
    path: '/',
    redirect: `${dir}/dataAnalysis`,
    component: Layout,
    name: 'Layout',
    children: [
      {
        path: dir + '/dataAnalysis',
        component: requireComponent('UGC/data-analysis'),
        name: 'dataAnalysis',
        meta: {
          title: '首页',
          icon: 'icon-shuju-on'
        }
      },
      {
        path: dir + '/programManagement',
        component: requireComponent('UGC/program-management'),
        name: 'programManagement',
        meta: {
          title: '作品管理' + dir,
          icon: 'icon-zuopinguanli-off'
        }
      },
      {
        path: dir + '/programGroupManagement',
        name: 'programGroupManagement',
        meta: {
          title: '专辑管理' + dir,
          icon: 'icon-zhuanji-on'
        },
        component: requireComponent('UGC/program-group-management')
      },
      {
        path: '/createGroup',
        name: 'createGroup',
        meta: {
          title: '新建专辑',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group-ugc.vue')
      },
      {
        path: '/editGroup',
        name: 'editGroup',
        meta: {
          title: '编辑专辑',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group-ugc.vue')
      },
      {
        path: '/newGroup',
        name: 'newGroup',
        meta: {
          title: '作品编目',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/program-group-ugc.vue')
      },
      {
        path: '/addAlbum',
        name: 'addAlbum',
        meta: {
          title: '作品添加到专辑',
          hidden: true
        },
        component: requireComponent('common/addAlbum.vue')
      },
      {
        path: dir + '/programGroupManagement/managementGroup',
        name: 'ugcmanagementGroup',
        meta: {
          title: '节目集管理',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('UGC/program-group-management/management-group.vue')
      },
      {
        path: '/upload',
        name: 'uploadVideo',
        meta: {
          title: '上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-video.vue')
      },
      {
        path: '/sdk',
        name: 'uploadFile',
        meta: {
          title: 'SDK上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-sdk-file.vue')
      },
      {
        path: '/uploadFile',
        name: 'uploadVideo',
        meta: {
          title: '上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-file.vue')
      },
      {
        path: '/batchJoinAlbum',
        name: 'batchJoinAlbum',
        meta: {
          title: '添加到专辑',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/batchJoinAlbum.vue')
      }
      // ,
      // {
      //   path: dir + '/revenueManagement',
      //   component: requireComponent('UGC/revenue-management'),
      //   name: 'revenueManagement',
      //   meta: {
      //     title: '收益管理' + dir,
      //     icon: 'revenueManagement',
      //     hidden: true
      //   }
      // },
    ]
  },
  {
    path: dir + '/dataCenter',
    name: 'dataCenter',
    redirect: `${dir}/dataAnalysis`,
    component: Layout,
    meta: {
      title: '数据中心',
      icon: 'icon-jiemu-on'
    },
    children: [
      {
        path: dir + '/worksProfit',
        component: requireComponent('UGC/data-center/worksProfit'),
        name: 'worksProfit',
        meta: {
          title: '作品收益'
        }
      },
      {
        path: dir + '/albumRevenue',
        component: requireComponent('UGC/data-center/albumRevenue'),
        name: 'albumRevenue',
        meta: {
          title: '专辑收益'
        }
      }
    ]
  }
]
export default UGCRouter
